const DatabaseItemTitle = ({ record }) => {
    return <span>Database Item {record ? `"${record.hostname}"` : ''}</span>;
};

export default DatabaseItemTitle;